import { render, staticRenderFns } from "./RankMapSetNew.vue?vue&type=template&id=66b1abde"
import script from "./RankMapSetNew.vue?vue&type=script&lang=js"
export * from "./RankMapSetNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports